import React from 'react';
import Page from '../../components/UI/layout/Page';
import PageTitle from '../../components/UI/layout/PageTitle';
import SectionTitle from '../../components/UI/information-pages/SectionTitle';
import InfoParagraph from '../../components/UI/information-pages/InfoParagraph';


const AccessibilityStatementPage = () => {

    return (
        <Page>

            <div className='container'>

                <div className='row mt-4 mb-4'>
                    <div className='col-12'>
                        <PageTitle title="הצהרת נגישות" withReturnBtn />
                    </div>
                    <div className='col-12'>
                        <h4>עודכן: 8.7.2024</h4>
                    </div>
                </div>

                <InfoParagraph>
                    <div>
                        הצהרת נגישות
                        אתר אינטרנט נגיש הוא אתר המאפשר לאנשים עם מוגבלות ולאנשים מבוגרים לגלוש באותה רמה של יעילות והנאה ככל הגולשים.
                        כ-20 עד 25 אחוזים מהאוכלוסייה נתקלים בקשיי שימוש באינטרנט ועשויים להיטיב מתכני אינטרנט נגישים יותר, כך על פי מחקר שנערך בשנת 2003 ע"י חברת מייקרוסופט.
                    </div>
                    <div>
                        חברת לולהטק - חברת תוכנה, מאמינה ופועלת למען שוויון הזדמנויות במרחב האינטרנטי לבעלי לקויות מגוונות ו/או המסתייעים בטכנולוגיות עזר לשימוש במחשב.
                    </div>
                </InfoParagraph>

                <InfoParagraph title="נגישות האתר">
                    <div>
                        אתר זה עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג 2013.
                        האתר תואם את המלצות התקן הישראלי (ת"י 5568) לנגישות תכנים באינטרנט ברמתAA ואת המלצות מסמך WCAG2.0 מאת ארגון W3C.
                        כמו כן, מותאם לתצוגה בדפדפנים הנפוצים ולשימוש בטלפון הסלולארי.
                    </div>
                </InfoParagraph>

                <InfoParagraph title="תיקונים שבוצעו">
                    <div>
                        באתר זה בוצעו התאמות נגישות קפדניות הכוללות בין היתר מימוש סמנטי ואינפורמטיבי עבור טכנולוגיות מסייעות, קביעת ניווט והפעלה עם מקלדת בלבד עפ"י המלצות ארגון התקינה ברשת הבינלאומי (W3C), התאמות צבעים וכן הוספת תוויות עזר והנחיות בטפסים לטובת כלל הגולשים. כמו כן, לשם קבלת חווית גלישה מיטבית עם תוכנת הקראת מסך, אנו ממליצים לשימוש בתוכנת NVDA העדכנית ביותר.
                    </div>
                </InfoParagraph>

                <InfoParagraph title="חלק מהדברים שבוצעו באתר">
                    <div>
                        הוספנו אפשרות לניווט מקלדת המקלה על גלישה באתר ללא שימוש עכבר, התאמות לתאימות האתר לגלישה עם קורא מסך, יצירת נוחות לצפייה באתר בגווני שחור לבן/ ניגודיות צבעים, לחסום אנימציה וכל רכיב הזז באתר, להבליט קישורים.
                        יש לציין כי למרות מאמצנו להנגיש את כלל הדפים באתר, המסמכים המצורפים (כגון, , Word, Excel), ככל שיהיו, מערכת ניהול פנימית וקבצי וידאו מצויים עדיין בשלבי הנגשה ואנו פועלים להשלים זאת.
                        שימו לב שבשל אופיו הדינמי של האתר, עלולות להופיע בעיות קלות מדי פעם מכיוון שהוא מתעדכן באופן שוטף. אנו מחפשים ללא הרף פתרונות שיביאו את כל אזורי האתר לאותה רמה של נגישות אינטרנט כוללת.
                        במידה ונדרש לכם מסמך המופיע באתר והוא אינו נגיש, אנא פנו אלינו עם קישור למקום ונדאג לכך בהקדם.
                        במידה ומצאתם רכיב או עמוד שלא נגיש באתר נשמח אם תפנו אלינו ואנחנו נדאג לתקן בהקדם.
                    </div>
                </InfoParagraph>
            
                <InfoParagraph title="יצירת קשר">
        
                    <div>
                        אם במהלך הגלישה באתר נתקלת בבעיה בנושא נגישות נשמח אם תדווחו לנו ואנחנו נדאג לתקן בהקדם.
                        <br />
                        פרטים של רכז נגישות בארגון שם: נדב גלמן
                        <br />
                        טלפון: <strong>077-7944440</strong> שלוחה 5
                        <br />
                        אימייל: <strong>support@lola-tech.com</strong>
                    </div>
                </InfoParagraph>


            </div>
        </Page>
    );
}

export default AccessibilityStatementPage;